<!--
  A view used to test the code editor
-->

<template>
  <div>
    <h3>code</h3>
    <el-form @submit.native.prevent="parse">
      <!-- <el-input type="textarea" v-model="code" :rows=20></el-input> -->
      <el-code-input :type="type" v-model="code"></el-code-input>
      <div style="text-align: center;">
        <el-button native-type="submit">Validate</el-button>
      </div>
    </el-form>
    <template v-if="output.code">
      <pre class="moo"
        ><span
          v-for="tag in output.code"
          :key="tag.offset"
          :class="['code', tag.cls, {'compilation-error': tag.error}, {'runtime-error': output.errorOffsets[tag.offset]}]"
          >{{ tag.text
          }}<span v-if="tag.error"
            class="error-tooltip">
            {{ tag.error }}
          </span
        ></span
      ></pre>
    </template>
    <template v-if="output.error">
      <h3>error</h3>
      <p>{{output.error.name}}: {{output.error.message}}</p>
      <ul>
        <li v-for="position in output.error.codestack"
            :key="position.offset">
          line {{position.line}} column {{position.col}}
        </li>
      </ul>
    </template>
    <template v-if="output.code">
      <h3>input</h3>
      <pre>{{output.input}}</pre>
    </template>
    <template v-if="output.value">
      <h3>value</h3>
      <pre>{{output.value}}</pre>
    </template>
    <template v-if="output.output">
      <h3>output</h3>
      <pre>{{output.output}}</pre>
    </template>
    <template v-if="output.debug">
      <h3>debug</h3>
      <pre>{{output.debug}}</pre>
    </template>
  </div>
</template>

<script>
import { Parser, ParserError } from '../utils/parser.js'
import ElCodeInput from './element/ElCodeInput.vue'

export default {
  components: {
    ElCodeInput,
  },

  data () {
    return {
      type: 'program',
      // type: 'value',
      code: '@@x = @@f(2, 4)',
      // code: '2 + 2',
      // `
      // delete @@lala.lolo
      // @@f = fun(@@a, @@b) @@a + @@b
      // @@x = @@f(2, 4)
      // `,
      value: null,
      input: {
        script: { lala: { lolo: 4 } },
        local: {},
        context: {},
        contexts: {},
        // global: { console: console },
      },
      output: {
        code: [],
        input: '',
        value: '',
        error: null,
        output: '',
        debug: '',
      },
    }
  },

  created () {
    if (this.$route.query.code) {
      this.code = decodeURIComponent(this.$route.query.code)
    }
    this.parse()
  },

  methods: {
    disp (value, indent) {
      if (indent) return JSON.stringify(value, null, 2)
      else return JSON.stringify(value)
    },
    parse () {
      this.$router.replace('/moo?code=' + encodeURIComponent(this.code))
      this.output = {}
      let variables = {
        ...this.input,
        script: JSON.parse(JSON.stringify(this.input.script)),
        local: JSON.parse(JSON.stringify(this.input.local)),
      }
      this.output.input = this.disp(variables, true)
      let parser = new Parser(this.code)
      window._parser = parser
      let value = this.type === 'program'
        ? parser.parseProgram() : parser.parseValueProgram()
      this.output.debug = this.disp(value, true)
      let tags = [], pos = 0
      for (let syntax of parser.syntax) {
        if (pos < syntax.offset) {
          tags.push({
            cls: 'code-space',
            text: this.code.substring(pos, syntax.offset),
          })
        }
        pos = syntax.offset + syntax.length
        let cls = []
        for (let t of syntax.type) {
          cls.push((cls.length ? cls[cls.length - 1] + '-' : 'code-') + t)
        }
        tags.push({
          ...syntax,
          cls: cls,
          text: this.code.substring(syntax.offset, pos),
        })
      }
      if (pos < this.code.length) {
        tags.push({
          cls: 'code-space',
          text: this.code.substring(pos),
        })
      }
      this.output.code = tags
      let result
      this.output.errorOffsets = {}
      try {
        result = value.resolve ? value.resolve(variables) : value.value
      } catch (error) {
        this.output.error = error
        console.error(error)
        if (error instanceof ParserError) {
          for (pos of error.codestack) {
            this.output.errorOffsets[pos.offset] = true
          }
          return
        } else throw error
      }
      this.output.value = this.disp(result)
      this.output.output = this.disp(variables, true)
    },
  },
}
</script>

<style>
  .moo {
    color: #333333;
  }
  .moo .code-operator {
    color: #f97b58;
  }
  .moo .code-operator-dot, .moo .code-operator-getter {
    color: #5fb4b4;
  }
  .moo .code-separator {
    color: #ac7a68;
  }
  .moo .code-number {
    color: #f97b58;
  }
  .moo .code-variable-script, .moo .code-variable-local, .moo .code-variable-argument {
    color: #6699cc;
  }
  .moo .code-variable-context, .moo .code-variable-contexts {
    color: #5fb4b4;
  }
  .moo .code-string {
    color: #99c794;
  }
  .moo .code-block {
    color: #c695ca;
  }
  .moo .code-literal {
    color: #ec5f66;
  }
  .moo .code-comment {
    color: #999999
  }

  .moo .compilation-error {
    position: relative;
    display: inline-block;
    border-bottom: 2px solid red;
    /*text-decoration: underline wavy red;*/
  }
  .moo .runtime-error {
    position: relative;
    display: inline-block;
    border-bottom: 2px solid purple;
    /*text-decoration: underline wavy red;*/
  }
  .moo .compilation-error .error-tooltip {
    visibility: hidden;
    /*width: 120px;*/
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -10px;
    opacity: 0;
    transition: opacity 0.3s;
  }
  /*.moo .error .error-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }*/
  .moo .error:hover .error-tooltip {
    visibility: visible;
    opacity: 1;
  }
</style>
